import AlertBlog from "../components/AlertBlog";
import Footer from "../components/Footer";
import HeaderBlog from "../components/HeaderBlog";
import InfoCard from "../components/InfoCard";
import ListaBlog from "../components/ListaBlog";
import Obs from "../components/Obs";
import TableBlog from "../components/TableBlog";
import TextoPadraoBlog from "../components/TextoPadraoBlog";
import TituloBlog from "../components/TituloBlog";


const RiscosDeNaoDeclararOsImpostosDevidosOQuePodeAcontecerComVoce = () => {
    return (
        <>
            <HeaderBlog
                titulo="Riscos de Não Declarar os Impostos Devidos: O Que Pode Acontecer Com Você"
                subtitulo="A Receita Federal não esquece. E quanto mais tempo você espera, mais caro fica. Conheça todos os riscos, e como sair dessa antes que seja tarde."
                data="19 de maio de 2025"
                tempoLeitura={9}
            />

            <TextoPadraoBlog
                texto={[
                    "Todo ano, milhares de autônomos, freelancers e criadores de conteúdo fazem a mesma escolha: deixar a declaração de imposto de renda para depois. Ou pior, fingir que o problema não existe.",
                    "O raciocínio parece lógico: Ninguém me fiscalizou até agora. Por que fariam isso desta vez?",
                    "A resposta é simples: porque a Receita Federal cruza dados automaticamente. Bancos, empresas, plataformas digitais, cartões de crédito, tudo alimenta os sistemas do Leão. Ele não precisa te procurar. Ele já sabe.",
                    "Neste artigo, você vai conhecer cada um dos riscos de não declarar os impostos devidos, e entender por que regularizar agora sai infinitamente mais barato do que esperar ser chamado.",
                ]}
            />

            <TituloBlog index={1} titulo="Multas que Crescem Exponencialmente" />

            <TextoPadraoBlog
                texto={[
                    "Vamos começar pelo mais imediato: o dinheiro que sai do seu bolso por simplesmente não declarar no prazo.",
                    "A multa por atraso na entrega da declaração de Imposto de Renda funciona assim:",
                ]}
            />

            <TableBlog titulos={["Situação", "Valor da multa"]} conteudo={[
                {
                    situacao: "Entrega com atraso (com imposto a pagar)",
                    valor: "1% ao mês sobre o imposto devido, limitado a 20%",
                },
                {
                    situacao: "Entrega com atraso (sem imposto a pagar)",
                    valor: "Mínimo de R$ 165,74",
                },
                {
                    situacao: "Não declarar mesmo sendo obrigado",
                    valor: "Até R$ 165,74 + 20% do imposto devido",
                },
                {
                    situacao: "Declaração com omissão de renda",
                    valor: "75% do imposto não declarado (podendo dobrar em casos de fraude)",
                }]}
            />

            <TextoPadraoBlog
                texto={[
                    "Parece abstrato? Pense assim: se você devia R$ 5.000 de imposto e ficou 10 meses sem declarar, a multa já chegou a R$ 500,00, fora os juros da Selic que correm em cima do valor principal.",
                ]}
            />

            <TituloBlog index={2} titulo="Malha fina: quando o Leão te chama para dar explicações" />

            <TextoPadraoBlog
                texto={[
                    "Malha fina não é punição, é uma auditoria. Mas quem já passou por ela sabe: é uma das experiências mais estressantes da vida financeira.",
                    "Você cai na malha fina quando a Receita Federal identifica inconsistências entre o que você declarou e o que os sistemas dela registraram. As causas mais comuns entre autônomos e freelancers são:",
                ]}
            />

            <ListaBlog itens={[
                "Receber pagamentos de empresas que emitiram informe de rendimentos no seu CPF e você não declarou",
                "Movimentações bancárias incompatíveis com a renda declarada",
                "Recebimentos via Pix em conta pessoal que caracterizam atividade profissional",
                "Rendimentos de plataformas digitais (YouTube, Hotmart, Monetizze) não informados",
                "Divergência entre notas fiscais emitidas e renda declarada",
            ]} />

            <AlertBlog texto="Enquanto seu CPF estiver retido em malha fina, sua restituição fica bloqueada e você pode ser convocado a comprovar cada centavo que entrou na sua conta." />

            <TituloBlog index={3} titulo="CPF bloqueado: a porta que fecha sem você perceber" />

            <TextoPadraoBlog
                texto={[
                    "O CPF é o seu passaporte financeiro. Quando ele fica com situação 'pendente de regularização' ou 'suspensa' na Receita Federal, as consequências aparecem nos momentos mais inconvenientes:",
                ]}
            />

            <ListaBlog itens={[
                "Impossibilidade de abrir conta em banco",
                "Reprovação em análise de crédito",
                "Impossibilidade de financiar imóvel ou veículo",
                "Dificuldade para assinar contratos com empresas",
                "Bloqueio para emitir passaporte e documentos oficiais",
                "Impedimento para abrir ou manter CNPJ ativo",
            ]} />

            <TextoPadraoBlog
                texto={[
                    "Para criadores de conteúdo e prestadores de serviço digital, um CPF bloqueado pode significar perda de contratos, impossibilidade de receber pagamentos formais e até encerramento forçado do negócio.",
                ]}
            />

            <TituloBlog index={4} titulo="Representação fiscal para fins penais: quando vira crime" />

            <TextoPadraoBlog
                texto={[
                    "Esse é o risco que a maioria das pessoas não sabe que existe, e é o mais grave.",
                    "Quando a Receita Federal identifica que houve omissão dolosa de rendimentos (ou seja, você sabia que devia declarar e escolheu não declarar), ela pode emitir uma Representação Fiscal para Fins Penais ao Ministério Público.",
                    "Isso significa que a situação deixa de ser administrativa e pode se tornar um processo criminal por sonegação fiscal, prevista na Lei nº 8.137/1990, com penas que vão de 2 a 5 anos de reclusão.",
                ]}
            />

            <AlertBlog texto="O pagamento integral do débito antes do início da ação penal extingue a punibilidade. Em outras palavras: regularizar antes de ser autuado ainda te protege. Depois que o processo começa, essa janela fecha." />

            <TituloBlog index={5} titulo="Dívida ativa e protesto em cartório" />

            <TextoPadraoBlog
                texto={[
                    "Se o imposto não declarado gera um débito que não é pago, a Receita Federal inscreve esse valor em Dívida Ativa da União, e aí o nível de problema sobe consideravelmente.",
                    "A partir desse ponto, você pode enfrentar:",
                ]}
            />

            <ListaBlog itens={[
                "Protesto do débito em cartório (afeta seu nome no mercado)",
                "Penhora de bens, incluindo conta bancária e veículos",
                "Inclusão em cadastros de inadimplentes fiscais",
                "Impossibilidade de participar de licitações públicas",
                "Restrição para obter certidão negativa de débitos, exigida em contratos, financiamentos e abertura de empresas",
            ]} />

            <TextoPadraoBlog
                texto={[
                    "Para quem trabalha como PJ ou MEI, a ausência de uma Certidão Negativa de Débitos (CND) pode inviabilizar negócios inteiros.",
                ]}
            />

            <TituloBlog index={6} titulo="Perda de restituição: você pode estar deixando dinheiro na mesa" />

            <TextoPadraoBlog
                texto={[
                    "Esse risco é diferente dos outros, não é uma punição. É uma perda silenciosa.",
                    "Quem tem imposto a restituir e não declara simplesmente abre mão desse dinheiro. A restituição não aparece automaticamente na sua conta, ela exige a entrega da declaração.",
                    "Freelancers e autônomos que tiveram imposto retido na fonte por clientes e não declararam estão, literalmente, deixando dinheiro que é seu dentro do cofre da Receita Federal.",
                ]}
            />

            <Obs texto="O prazo para declarar e resgatar uma restituição prescreve em 5 anos. Depois disso, o valor é incorporado definitivamente ao caixa da União. O dinheiro se foi." />

            <TituloBlog index={7} titulo="Impossibilidade de comprovar renda: o obstáculo invisível" />

            <TextoPadraoBlog
                texto={[
                    "Pense no seguinte cenário: você faturou bem nos últimos dois anos como designer freelancer. Decidiu comprar um apartamento. Foi ao banco. E na hora de apresentar a comprovação de renda, não tem nada.",
                    "Sem declaração de IR, o banco não reconhece sua renda. Sem reconhecimento de renda, não há crédito. Sem crédito, o apartamento fica para outra pessoa.",
                    "Para autônomos e criadores de conteúdo, a declaração anual de IR é o equivalente ao holerite de quem tem CLT. É o único documento que comprova formalmente que você existe financeiramente, e que seu negócio é real.",
                ]}
            />

            <Obs texto="Você pode até faturar bem. Mas se o papel não existir, para o sistema financeiro você também não existe." />

            <InfoCard destino="/Blog/beneficios-de-declarar-corretamente-os-impostos" />

            <TituloBlog index={8} titulo="Ainda dá para regularizar, mas quanto antes, melhor" />

            <TextoPadraoBlog
                texto={[
                    "Se você se identificou com algum dos riscos acima, a boa notícia é que ainda há tempo de agir.",
                    "A Receita Federal permite a entrega de declarações em atraso a qualquer momento, e quanto antes você regularizar, menor será a multa acumulada. Existe também o programa de autorregularização, que permite ajustar inconsistências antes de virar autuação formal.",
                    "O caminho é simples:",
                ]}
            />

            <ListaBlog itens={[
                "Levantar todos os rendimentos dos anos em aberto",
                "Entregar as declarações retroativas com os valores corretos",
                "Quitar o imposto devido + multa + juros (que serão menores do que se esperar mais)",
                "Regularizar o CPF e, se necessário, o CNPJ",
            ]} />

            <TextoPadraoBlog
                texto={[
                    "Fazer isso sozinho é possível, mas arriscado. Um erro na declaração retroativa pode transformar uma regularização em uma nova inconsistência. Ter um contador especializado ao seu lado muda tudo.",
                ]}
            />

            <Footer />
        </>
    );
}

export default RiscosDeNaoDeclararOsImpostosDevidosOQuePodeAcontecerComVoce;